import React, { Component } from "react";
import SearchWrapper from "./layouts/SearchWrapper";
import Header from "./layouts/Header";
import Banner from "./layouts/Banner";
import OurHistory from "./layouts/OurHistory";
import Staff from "./layouts/Staff";
import OurNews from "./layouts/OurNews";
import Brands from "./layouts/Brands";
import Footer from "./layouts/Footer";
import Shop from "./layouts/Shop";
import PlayWithUs from "./layouts/PlayWithUs";

class Home extends Component {
    render() {
        return (
            <>
                <SearchWrapper />
                <Header />
                <Banner />
                <PlayWithUs/>
                {/* <Fixtures /> */}
                <OurNews />
                <Staff />
                <OurHistory/>
                <Shop/>
                <Brands />
                <Footer />
            </>
        );
    }
}

export default Home;